import React from 'react'
import ContactLinks from '../ContactLinks/ContactLinks'

interface PhoneBlockingDialogProps {
  contactLinkId?: string
}

export const PhoneBlockingDialog: React.FC<PhoneBlockingDialogProps> = ({
  contactLinkId = 'link-contact'
}) => (
  <div data-testid='phone-blocking-container' className='bg-black flex justify-center items-center min-h-screen w-full p-4'>
    <div className='glow-effect max-w-md w-full'>
      <div className='diamond-corner p-1 bg-dopage-lightGreen w-full'>
        <div className='inner bg-black'>
          <div className='py-8 px-4 flex flex-col justify-center items-center text-dopage-darkGreen'>
            <h2 className='text-xl font-bold mb-6 w-full text-center text-dopage-lightGreen'>
              Grab your computer or tablet!
            </h2>
            <p className='text-base text-center text-dopage-lightGreen mb-4 w-full'>
              The DopaGE Overdose Prevention Portal is not accessible via mobile device.
              {' '}<span className='font-bold'>We sent a sign in link to your email for easy access once you get back to your laptop, desktop computer, or tablet.</span>
            </p>
            <div className='mt-4'>
              <ContactLinks id={contactLinkId} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
